var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { GET_CALL_HISTORY, GetCallHistoryFailureAction, GetCallHistorySuccessAction, SetCallHistoryParamsAction } from './call-history.actions';
import { CallHistoryService } from './call-history.service';
import { select, Store } from '@ngrx/store';
import { getCallHistoryPageSelector } from './call-history.reducer';
var CallHistoryEffects = /** @class */ (function () {
    function CallHistoryEffects(actions$, callHistoryService, store) {
        var _this = this;
        this.actions$ = actions$;
        this.callHistoryService = callHistoryService;
        this.store = store;
        this.getCallHistory$ = this.actions$.pipe(ofType(GET_CALL_HISTORY), map(function (action) { return action.payload; }), withLatestFrom(this.store.pipe(select(getCallHistoryPageSelector))), switchMap(function (_a) {
            var payload = _a[0], params = _a[1];
            var completeParams = __assign({}, params, payload);
            return _this.callHistoryService.getCallHistory(_this.escapeUnassignedUser(completeParams)).pipe(switchMap(function (response) {
                return [new GetCallHistorySuccessAction(response), new SetCallHistoryParamsAction(completeParams)];
            }), catchError(function (error) { return of(new GetCallHistoryFailureAction(error)); }));
        }));
    }
    CallHistoryEffects.prototype.escapeUnassignedUser = function (searchParams) {
        var agentIds = (searchParams && searchParams.agentIds ? searchParams.agentIds : []).map(function (id) { return (id === CallHistoryService.UNASSIGNED_USER_ID ? null : id); });
        return __assign({}, searchParams, { agentIds: agentIds });
    };
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], CallHistoryEffects.prototype, "getCallHistory$", void 0);
    return CallHistoryEffects;
}());
export { CallHistoryEffects };
